import { textSizeToContentWidth } from '../../utility/index.js';

// header 1
textSizeToContentWidth('.hero-header-1__word', '.hero-header-1__title');

// header 4
textSizeToContentWidth('.hero-header-4__subtitle', '.hero-header-4__content');
textSizeToContentWidth('.hero-header-4__title', '.hero-header-4__content');
textSizeToContentWidth('h2', '.hero-header-4__content');
textSizeToContentWidth('h1', '.hero-header-4__content');

// const event = () => {
// if (!document.querySelector('.hero-header-1__title--animated')) return;
// const currentClass = 'hero-header-1__word--active';
// const getWords = () => [...document.querySelectorAll('.hero-header-1__word')];
// getWords()?[0].classList.add(currentClass);

// const changeWord = () => {
//   const words = getWords();
//   let currentEl = words.filter((el) => el.matches(`.${currentClass}`));

//   if (currentEl.length > 0) currentEl = currentEl[0];

//   const position = words.indexOf(currentEl);
//   const next = position + 1 > words.length - 1 ? 0 : position + 1;

//   words[position].classList.remove(currentClass);
//   words[next].classList.add(currentClass);
// };

// window.heroHeaderInterval = setInterval(changeWord, 3000);

// Resize Title Text to match SVG

//   const textResize = () => {
//     const svgText = parseInt(document.querySelector('.hero-header__title--animated').getBoundingClientRect().height);
//     [...document.querySelectorAll('.hero-header__title span')].map(el => {
//       el.style.fontSize = `${svgText}px`;
//       console.log({ svgText: svgText, svgHeight: `${svgText}px` });
//     });
//   };

//   textResize();
//   window.addEventListener('resize', () => textResize());
// };

// document.addEventListener('DOMContentLoaded', event);
// document.addEventListener('vue:loaded', event);

// const textResize = () => [...document.querySelectorAll('.hero-header__title span')].map(el => (el.style.fontSize = (parseInt(document.querySelector('.hero-header__word').getBoundingClientRect().height) / 1.315) + 'px'));

// const responsiveTextResize = (dir = 'add') => () => {
//   if (dir === 'remove') [...document.querySelectorAll('.hero-header__title span')].map(el => el.style.fontSize = '');
//   document[dir == 'add' ? 'addEventListener' : 'removeEventListener']('DOMContentLoaded', textResize);
//   window[dir == 'add' ? 'addEventListener' : 'removeEventListener']('resize', textResize);
// };

// window.responsive('mobile', responsiveTextResize('add'));
// window.responsive('tablet', responsiveTextResize('add'));
// window.responsive('desktop', responsiveTextResize('add'));
// window.responsive('ultrawide', responsiveTextResize('add'));

document.addEventListener(
  'click',
  (e) =>
    e.target.matches('.hero-header-1__button') &&
        window.scrollTo(
          0,
          e.target.closest('.hero-header-1').getBoundingClientRect().height +
                parseInt(getComputedStyle(e.target.closest('.hero-header-1'))['margin-bottom'])
        )
);


// Header 3
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.hero-header-3__video') === null) {
    return;
  }

  // document.addEventListener('DOMContentLoaded', () => [...document.querySelectorAll('iframe')].map(iframe => iframe.addEventListener('loaded', e.target.closest('.hero-header-3').classList.add('hero-header-3--loaded'))));
  document.addEventListener('video:loaded', e => e.target.matches('.hero-header-3 .hero-header-3__video-fg iframe') && setTimeout(() => e.target.closest('.hero-header-3').classList.add('hero-header-3--loaded'), 3000));

  document.addEventListener('video:loaded', () => {
    // console.log('TTEST');

    callPlayer('youtube-video', 'playVideo');
  });

  // document.addEventListener('video:loaded', e => e.target.matches('.hero-header-3:not(.hero-heder-3--load-in) .hero-header-3__video-fg iframe') && setTimeout(() => e.target.closest('.hero-header-3').classList.add('hero-header-3--loaded'), 2000));
  document.addEventListener('scroll', e => document.querySelector('.hero-header-3__video') && (document.querySelector('.hero-header-3__video').style.transform = `translateY(${window.scrollY}px)`));

  // Makes header 3 to always behave as if navbar was set to overlap (resets header grid area height)
  if ( ! document.body.classList.contains('navbar-overlap') ) {
    document.body.classList.add('navbar-overlap-header-3');
  }
});





[...document.querySelectorAll('.book-input-item')].map(el =>
  el.querySelector('.selectboxit-text')
  ? (el.querySelectorAll('select')) && (el.querySelector('.selectboxit-text').innerHTML = el.querySelector('select option').innerText)
    || (el.querySelector('.selectboxit-text').innerHTML = el.querySelector('input[type="hidden"]').value)
  :  [...el.querySelectorAll('input')].map(input => (input.value='')));
            


function callPlayer(frame_id, func, args) {
  if (window.jQuery && frame_id instanceof jQuery) frame_id = frame_id.get(0).id;
  let iframe = document.getElementById(frame_id);
  if (iframe && iframe.tagName.toUpperCase() !== 'IFRAME') {
    iframe = iframe.getElementsByTagName('iframe')[0];
  }

  // When the player is not ready yet, add the event to a queue
  // Each frame_id is associated with an own queue.
  // Each queue has three possible states:
  //  undefined = uninitialised / array = queue / .ready=true = ready
  if (!callPlayer.queue) callPlayer.queue = {};
  let queue = callPlayer.queue[frame_id],
    domReady = document.readyState === 'complete';

  if (domReady && !iframe) {
    // DOM is ready and iframe does not exist. Log a message
    window.console && console.log('callPlayer: Frame not found; id=' + frame_id);
    if (queue) clearInterval(queue.poller);
  } else if (func === 'listening') {
    // Sending the "listener" message to the frame, to request status updates
    if (iframe && iframe.contentWindow) {
      func = '{"event":"listening","id":' + JSON.stringify('' + frame_id) + '}';
      iframe.contentWindow.postMessage(func, '*');
    }
  } else if ((!queue || !queue.ready) && (
    !domReady ||
    iframe && !iframe.contentWindow ||
    typeof func === 'function')) {
    if (!queue) queue = callPlayer.queue[frame_id] = [];
    queue.push([func, args]);
    if (!('poller' in queue)) {
      // keep polling until the document and frame is ready
      queue.poller = setInterval(function () {
        callPlayer(frame_id, 'listening');
      }, 250);
      // Add a global "message" event listener, to catch status updates:
      messageEvent(1, function runOnceReady(e) {
        if (!iframe) {
          iframe = document.getElementById(frame_id);
          if (!iframe) return;
          if (iframe.tagName.toUpperCase() !== 'IFRAME') {
            iframe = iframe.getElementsByTagName('iframe')[0];
            if (!iframe) return;
          }
        }
        if (e.source === iframe.contentWindow) {
          // Assume that the player is ready if we receive a
          // message from the iframe
          clearInterval(queue.poller);
          queue.ready = true;
          messageEvent(0, runOnceReady);
          // .. and release the queue:
          while (tmp = queue.shift()) {
            callPlayer(frame_id, tmp[0], tmp[1]);
          }
        }
      }, false);
    }
  } else if (iframe && iframe.contentWindow) {
    // When a function is supplied, just call it (like "onYouTubePlayerReady")
    if (func.call) return func();
    // Frame exists, send message
    iframe.contentWindow.postMessage(JSON.stringify({
      "event": "command",
      "func": func,
      "args": args || [],
      "id": frame_id
    }), "*");
  }
}

/* IE8 does not support addEventListener... */
function messageEvent(add, listener) {
  const w3 = add ? window.addEventListener : window.removeEventListener;
  w3
    ? w3('message', listener, !1)
    : (add ? window.attachEvent : window.detachEvent)('onmessage', listener)
  ;
}
